//Style
import { useState } from "react";
import Styles from "./DropDown.module.scss";


import { ReactComponent as DropDownIcon } from "../../icons/common/dropdown.svg";


interface DropDownProps {
    options: any[]
    selected: number;
    position?:"top"|"bottom";
    handleClick: (data: number) => void;
}

const DropDown = ({ options, selected, position="top", handleClick }: DropDownProps) => {

    const [isVisible, setVisible] = useState(false)


    const handleOptionClick=(index:number)=>{
        setVisible(!isVisible)
        handleClick(index)
    }

    return (
        <div className={Styles.container}>
            <div className={Styles.dropdown_toggler} onClick={()=>{setVisible(!isVisible)}}>
                <div className={Styles.label}>
                    {options[selected].label}
                </div>
                <div className={Styles.icon}> <DropDownIcon width={18} height={18} />
                </div>            
            </div>

            {
                isVisible &&
                <div className={Styles.dropdown} style={position==="top"?{top:0}:{bottom:0} }>
                    {options.map((option,index) => {
                        return (
                            <div className={Styles.option} style={index!=options.length-1 ?{borderBottom:"1px solid rgba(var(--subabs),.25)"}:{}} onClick={()=>{handleOptionClick(index)}} key={option.id+"_"+index}>{option.label}</div>
                        )
                    })}
                </div>
            }
        </div>
    )
}

export default DropDown
